"use client"

import { useEffect, useState } from "react"
import { Select, Space, Typography } from "antd"
import _ from "lodash"
import { filterOption, getCurrentUserRole, ROLES_NAME } from "modules/utilities/utility"
import { CATEGORY } from "modules/my_tickets/data"
import {isComplaintTeam} from "../navbar/top/helper";
import {useOrderSearchForTicket, useTicketConfig} from "./store";


const { Text } = Typography
const { COMMUNITY, ORM, SUPER_ADMIN, MEDICAL_REP } = ROLES_NAME
const {
    MEDICAL_ESCALATIONS,
    NEGATIVE_REVIEWS_ORM,
    PAYMENTS,
    ORDER_RELATED,
    DELIVERY_RELATED_ISSUES,
    DAMAGED_PRODUCT,
    MISMATCH_PRODUCT,
    MISSING_PRODUCT,
    REVERSE_PICK_UP,
    PRODUCT_RELATED_QUALITY_ISSUES,
    COMMUNITY_ESCALATION,
    FIVE_MONTH_MONEY_BACK,
    MEDICAL_DOCUMENT,
} = CATEGORY

const role = getCurrentUserRole()

const Category = ({
                      selectedOrder,
                      selectedCategory,
                      setSelectedCategory,
                      setTicketPayload,
                      setValidation,
                      setSubcategoryOptions,
                      setInlineCall,
                  }) => {
    const { crmCategories } = useOrderSearchForTicket()
    const { ticketConfig, fetchTicketConfigByOrderId } = useTicketConfig()
    const ticketConfigByOrderId = useTicketConfig((state) => state.ticketConfigByOrderId)

    const [categoriesToMap, setCategoryToMap] = useState([])
    const [dynamicConfig, setDynamicConfig] = useState({})

    useEffect(() => {
        if (ticketConfigByOrderId && Object.keys(ticketConfigByOrderId).length > 0) {
            setDynamicConfig(_.cloneDeep(ticketConfigByOrderId))
        } else {
            setDynamicConfig({})
        }
    }, [ticketConfigByOrderId])

    useEffect(() => {
        if (selectedCategory && Object.keys(dynamicConfig).length > 0) {
            const subcategories = categoriesToMap.find((category) => category.value === selectedCategory)
            let subcategoriesToMap = _.get(subcategories, ["subcategory"], [])
            subcategoriesToMap = [ORM, SUPER_ADMIN].includes(role)
                ? subcategoriesToMap
                : subcategoriesToMap.filter((item) => item.value !== NEGATIVE_REVIEWS_ORM)
            subcategoriesToMap = [COMMUNITY, SUPER_ADMIN].includes(role)
                ? subcategoriesToMap
                : subcategoriesToMap.filter((item) => item.value !== COMMUNITY_ESCALATION)
            subcategoriesToMap = [MEDICAL_REP].includes(role)
                ? subcategoriesToMap.filter((item) => item.value !== MEDICAL_DOCUMENT)
                : subcategoriesToMap
            if (selectedCategory === PAYMENTS) {
                subcategoriesToMap = isComplaintTeam()
                    ? subcategoriesToMap
                    : subcategoriesToMap.filter((item) => item.value !== FIVE_MONTH_MONEY_BACK)
            }

            subcategoriesToMap = subcategoriesToMap.map((subcat) => {
                const configData = dynamicConfig[subcat.value] || {}
                const merged = { ...configData, ...subcat }
                if (configData?.flow_questions?.length > 0) merged.flow_questions = configData.flow_questions
                return merged
            })

            setSubcategoryOptions(subcategoriesToMap)
        }
    }, [dynamicConfig, selectedCategory, categoriesToMap, role])

    useEffect(() => {
        setValidation((prev) => ({ ...prev, category: false, subcategory: false }))
    }, [])

    useEffect(() => {
        if (crmCategories.length > 0) {
            const paymentIssue = crmCategories.filter((category) => category.value === PAYMENTS)
            if (_.isEmpty(selectedOrder)) setCategoryToMap(paymentIssue)
            else setCategoryToMap(crmCategories)
        }
    }, [crmCategories])

    useEffect(() => {
        setCategoryToMap(crmCategories)
    }, [selectedOrder])

    const onCategoryChange = (value) => {
        setValidation((prevValidation) => {
            const { remark, ...rest } = prevValidation
            return { ...rest }
        })
        if (value === PAYMENTS && Object.keys(selectedOrder).length === 0) {
            setValidation((prevValidation) => ({ ...prevValidation, order_display_id: true }))
        }

        setTicketPayload((payload) => {
            const { inline_input_comment, inline_transfer, ...rest } = payload
            const data = { ...rest, category: value, sub_category: null, products: [], total_refund_price: "0.00" }
            value === PRODUCT_RELATED_QUALITY_ISSUES ? (data.is_internal = true) : (data.is_internal = false)
            return data
        })

        setValidation((prevValidation) => ({ ...prevValidation, category: value ? true : false, subcategory: false }))

        setSelectedCategory(value)
        setInlineCall(false)

        if (value === undefined || value !== ORDER_RELATED) {
            setValidation((prevPayload) => {
                const { request_type, products, ...rest } = prevPayload
                return { ...rest }
            })
        }

        const subcategories = categoriesToMap.find((category) => category.value === value)
        let subcategoriesToMap = _.get(subcategories, ["subcategory"], [])
        subcategoriesToMap = [ORM, SUPER_ADMIN].includes(role)
            ? subcategoriesToMap
            : subcategoriesToMap.filter((item) => item.value !== NEGATIVE_REVIEWS_ORM)
        subcategoriesToMap = [COMMUNITY, SUPER_ADMIN].includes(role)
            ? subcategoriesToMap
            : subcategoriesToMap.filter((item) => item.value !== COMMUNITY_ESCALATION)
        subcategoriesToMap = [MEDICAL_REP].includes(role)
            ? subcategoriesToMap.filter((item) => item.value !== MEDICAL_DOCUMENT)
            : subcategoriesToMap
        if (value === PAYMENTS) {
            subcategoriesToMap = isComplaintTeam()
                ? subcategoriesToMap
                : subcategoriesToMap.filter((item) => item.value !== FIVE_MONTH_MONEY_BACK)
        }

        subcategoriesToMap = subcategoriesToMap.map((subcat) => {
            const configData = dynamicConfig[subcat.value] || {}
            const merged = { ...configData, ...subcat }
            if (configData?.flow_questions?.length > 0) merged.flow_questions = configData.flow_questions
            return merged
        })

        setSubcategoryOptions(subcategoriesToMap)

        setValidation((prevValidation) => {
            const { slot, ...rest } = prevValidation
            return { ...rest }
        })

        if (selectedOrder && value) fetchTicketConfigByOrderId(selectedOrder.id, value)
    }

    return (
        <>
            <Space.Compact block className="my-2">
        <span
            style={{ background: "#FAFAFA", border: "#D9D9D9", width: "30%" }}
            className="border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2"
        >
          <Text>Select Category</Text>
        </span>
                <Select
                    style={{ width: "70%" }}
                    showSearch
                    allowClear
                    placeholder="Select a Category"
                    optionFilterProp="children"
                    value={selectedCategory}
                    onChange={onCategoryChange}
                    filterOption={filterOption}
                    options={categoriesToMap.filter(Boolean)}
                />
            </Space.Compact>
        </>
    )
}

export default Category
